export default "__VITE_ASSET__6b498b51__"